export enum TypeListMenu {
  OPTION = 'OPTION',
  WHATSAPP = 'WHATSAPP',
  PHONE = "PHONE",
  RRSS = "RRSS"
}
